import { useContext } from 'react'

import { MrpScheduledPurchaseContext } from '@provider/Mrp/ScheduledPurchaseProvider'

import type { IMrpScheduledPurchaseContext } from '@base/@types/providers/Mrp/ScheduledPurchaseProvider'

export default function useMrpScheduledPurchase(): IMrpScheduledPurchaseContext {
  const context = useContext(MrpScheduledPurchaseContext)

  return context
}
